import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, Subject, catchError, throwError, switchMap, filter, take } from 'rxjs';
import { AuthService } from '../auth/auth.service';

let refreshInFlight: Observable<{ accessToken: string; refreshToken: string }> | null = null;
const refreshComplete = new Subject<string | null>();

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const accessToken = authService.getAccessToken();

  let authReq = req;
  if (accessToken && !req.url.includes('/auth/login') && !req.url.includes('/auth/register')) {
    authReq = req.clone({
      setHeaders: { Authorization: `Bearer ${accessToken}` },
    });
  }

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        error.status !== 401 ||
        req.url.includes('/auth/refresh') ||
        req.url.includes('/auth/login')
      ) {
        return throwError(() => error);
      }

      // If a refresh is already in flight, wait for it instead of starting a new one.
      if (refreshInFlight) {
        return refreshComplete.pipe(
          filter((token) => token !== null),
          take(1),
          switchMap((token) =>
            next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })),
          ),
        );
      }

      refreshInFlight = authService.refreshToken();
      return refreshInFlight.pipe(
        switchMap((tokens) => {
          refreshInFlight = null;
          refreshComplete.next(tokens.accessToken);
          return next(req.clone({ setHeaders: { Authorization: `Bearer ${tokens.accessToken}` } }));
        }),
        catchError((refreshError) => {
          refreshInFlight = null;
          refreshComplete.next(null);
          return throwError(() => refreshError);
        }),
      );
    }),
  );
};
